import {
  TOKENMETRICS_REQUEST,
  TOKENMETRICS_SUCCESS,
  TOKENMETRICS_FAILURE,
} from "../types/tokenMetrics.types";

const initialState = {
  storeItemResponse: "",
  error: "",
  loading: false,
};

const TokenMetricsReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOKENMETRICS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case TOKENMETRICS_SUCCESS:
      return {
        ...state,
        storeItemResponse: action.payload,
        loading: false,
      };
    case TOKENMETRICS_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};

export default TokenMetricsReducer;
